
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IWbuDropdownProps,
  IWbuDropdownMapperProps,
  IWbuDropdownControllerProps,
  IWbuDropdownStateValues,
} from '../../../components/WbuDropdown/WbuDropdown.props';

export default withCompController<
  IWbuDropdownMapperProps,
  IWbuDropdownControllerProps,
  IWbuDropdownProps,
  IWbuDropdownStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
